import React from 'react'
import { Link as MUILink } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

interface FooterLinkProps {
  to: string
  children: React.ReactNode
}

const FooterLink: React.FC<FooterLinkProps> = ({ to, children }) => {
  return (
    <MUILink
      component={RouterLink}
      to={to}
      sx={{
        display: 'block',
        mb: 2,
        color: '#FFFFFF',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '22.4px',
        textAlign: 'left',
        textDecoration: 'none'
      }}
    >
      {children}
    </MUILink>
  )
}

export default FooterLink
